import { HOT_KEYS, useFeatureFlag } from '@shared/util/featureFlags';

/**
 * Whether the hotkeys feature is enabled (the `hot-keys` flag). While off,
 * `<HotKey>` registers nothing at all.
 */
export function useHotkeysEnabled(): boolean {
  return useFeatureFlag(HOT_KEYS);
}
